<template>
  <section
    v-loading="loading"
    class="new-case-view case-creation"
    id="single-case-view"
  >
    <div class="case-view-body">
      <div class="container-sm">
        <section id="view-case-screen">
          <PatientInformation></PatientInformation>
          <span class="case-creation__divider"></span>
          <CaseInformation></CaseInformation>
          <span class="case-creation__divider"></span>
        </section>
      </div>
    </div>
  </section>
  <section v-loading="loading" class="case-creation">
    <div class="container-sm">
      <div class="case-creation__step case-creation__patient-information">
        <div class="case-creation__card">
          <div class="case-creation__heading">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-case-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Mileage Information</h3>
            </div>
          </div>
          <div class="case-creation__body pb-0">
            <div class="vue-form">
              <el-form :model="mileageInformation">
                <el-row :gutter="15">
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text"
                          >Residence Type
                          <span class="star">*</span>
                        </label>
                        <el-input
                          type="text"
                          placeholder="Enter Residence Type"
                          v-model="mileageInformation.residence_type"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="residence_type"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text"
                          >Encore Miles
                          <span class="star">*</span>
                        </label>
                        <el-input
                          type="text"
                          placeholder="Enter Encore Miles"
                          v-model="mileageInformation.encore_miles"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="encore_miles"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text"
                          >Technician
                          <span class="star">*</span>
                        </label>
                        <el-input
                          type="text"
                          placeholder="Enter Technician"
                          v-model="mileageInformation.technician"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="technician"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">
                          Lab Drop-off
                          <span class="star">*</span>
                        </label>
                        <el-date-picker
                          type="date"
                          v-model="mileageInformation.lab_drop_off_date"
                          placeholder="MM-DD-YYYY"
                          format="MM-DD-YYYY"
                          value-format="YYYY-MM-DD"
                          :disabled-date="disabledDate"
                        ></el-date-picker>
                        <p class="err">
                          <FormError errorName="lab_drop_off_date"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text"> CPT Codes
                          <span class="star">*</span>
                         </label>
                        <div class="ten-icd-group d-flex">
                          <div
                            class="each-input mr-5"
                            v-for="(
                              cptCode, index
                            ) of mileage_cpt_codesForm"
                            :key="index"
                          >
                                <div class="icd-dropdown-style">
                                  <span>{{ cptCode.value }}</span>
                                </div>
                          </div>
                        </div>
                        <p class="err">
                          <FormError errorName="cpt_codes"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  
                  <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text"
                          >Mileage Address
                          <span class="star">*</span>
                        </label>
                        <el-input
                          type="text"
                          placeholder="Enter Mileage Address"
                          v-model="mileageInformation.mileage_address"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="mileage_address"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
        <div
          class="center-error-message pt-10 pb-20"
          v-if="this.getErrors && this.getErrors.critical_error"
        >
          <p class="err">
            <FormError errorName="critical_error"></FormError>
          </p>
        </div>
        <div class="case-creation__actions">
          <ul class="list">
            <li>
              <el-button type="button" class="btn cancel-button" @click="goBack"
                >Cancel</el-button
              >
            </li>

            <li v-if="mId">
              <el-button
                type="button"
                class="btn save-button"
                @click="askReason"
                >Update</el-button
              >
            </li>
            <li v-else>
              <el-button
                type="button"
                class="btn save-button"
                @click="createNewMileageCase"
                >Save</el-button
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <ResonForChange
    v-if="takeReasonDialog"
    v-on:close="takeReasonDialog = false"
    v-on:reasonSubmit="updateCase"
  ></ResonForChange>
</template>

<script>
const PatientInformation = defineAsyncComponent(() =>
  import("@/components/cases/PatientInformation")
);
const CaseInformation = defineAsyncComponent(() =>
  import("@/components/cases/CaseInformation")
);
const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);
const ResonForChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";

export default {
  components: {
    PatientInformation,
    CaseInformation,
    FormError,
    ResonForChange,
  },
  computed: {
    ...mapGetters("cases", [
      "getCaseInformation",
      "getMileageCaseInformation",
      "getMileageCaseUpdateStatus",
      "getMileageCaseAddStatus",
    ]),

    ...mapGetters("errors", ["getErrors", "getError"]),
  },
  data() {
    return {
      mileageInformation: {},
      caseId: "",
      accession_id: "",
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      loading: false,
      mId: "",
      takeReasonDialog: false,
      mileage_cpt_codesForm: [
        {
          sno: 1,
          value: "P9603",
        },
        {
          sno: 2,
          value: "36415",
        },
      ]   
    };
  },
  async mounted() {
    this.caseId = this.$route.params.case_id;
    await this.fetchCaseInformation();
    if (this.$route.params.m_id) {
      this.mId = this.$route.params.m_id;
      await this.fetchMileageCaseInfo();
    }
  },
  methods: {
    async fetchMileageCaseInfo() {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "cases/fetchMileageCaseInformation",
          this.mId
        );
        this.mileageInformation = { ...this.getMileageCaseInformation };
        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },
    async fetchCaseInformation() {
      try {
        this.loading = true;

        await this.$store.dispatch("cases/fetchCaseInformation", this.caseId);
        if (this.getCaseInformation) {
          this.accession_id = this.getCaseInformation.accession_id + "*M";
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    async createNewMileageCase() {
      try {
        this.loading = true;
        let params = { ...this.mileageInformation };
        params.cpt_codes = this.mileage_cpt_codesForm
          .filter((e) => e.value)
          .map((e) => e.value);
        params.accession_id = this.accession_id;
        params.case_id = this.caseId;
        await this.$store.dispatch("cases/addMileageCase", params);
        this.loading = false;
        if (this.getMileageCaseAddStatus) {
          successNotification("Mileage Case Updated Successfully");
          this.goBack();
        } else if (this.getErrors) {
          this.scrollToFirstError();
        } else {
          errorNotification("Error while updating Case");
        }
      } catch (err) {}
    },
    async askReason() {
      this.takeReasonDialog = true;
    },
    async updateCase(reason) {
      this.updateNewCase(reason);
    },
    async updateNewCase(reason) {
      try {
        this.loading = true;
        let params = { ...this.mileageInformation };
        params.accession_id = this.accession_id;
        const caseId = this.$route.params.case_id;
        params.case_id = caseId;
        params.mid = this.mId;
        params.update_reason = reason;
        params.cpt_codes = this.mileage_cpt_codesForm
          .filter((e) => e.value)
          .map((e) => e.value);
        await this.$store.dispatch("cases/updateMileageCase", params);
        if (this.getMileageCaseUpdateStatus) {
          successNotification("Mileage Case Updated Successfully");
          this.goBack();
        } else if (this.getErrors) {
          this.scrollToFirstError();
        } else {
          errorNotification("Error while updating Case");
        }
        this.loading = false;
        this.takeReasonDialog = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    goBack() {
      if (
        this.$route.params &&
        this.$route.params.case_id &&
        this.$route.params.m_id &&
        this.$route.query &&
        this.$route.query.redirectRoute
      ) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          name: "MileageCases",
          query: { ...this.$route.query, redirectRoute: this.$route.name },
        });
      }
    },
  },
};
</script>
